import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EntityService } from '../../shared/services/entity.service';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { SearchMode } from '../search/search-mode';
import { Subscription } from 'rxjs';
import { SmartSearchService } from '../../shared/services/smart-search.service';
import { SearchService } from '../../shared/services/search.service';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input({ required: true }) territoryUid!: string;
  @Input() embedded = false;

  entityId: string | null = null;
  currentPage!: string;

  /** Subscription to services */
  getEntityIdSubscription!: Subscription;

  constructor(
    private entityService: EntityService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private searchService: SearchService,
    protected smartSearchService: SmartSearchService
  ) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
      const currentUrl = event['urlAfterRedirects'];
      this.currentPage = this.getCurrentPage(currentUrl);
      this.smartSearchService.panelOpen.set(false);
    });
  }

  ngOnInit(): void {
    this.getEntityIdSubscription = this.entityService.getEntityId().subscribe(entityId => {
      this.entityId = entityId;
    });
    this.smartSearchService.resetSearchSession();
  }

  ngAfterViewChecked() {
    this.ref.detectChanges();
  }

  ngOnDestroy() {
    /** Unsubscribe to souscriptions */
    if (this.getEntityIdSubscription) {
      this.getEntityIdSubscription.unsubscribe();
    }
    this.searchService.resetText();
  }

  getCurrentPage(currentUrl: string): string {
    if (currentUrl.includes('/article')) {
      return 'article';
    } else if (currentUrl.includes('/admin-doc')) {
      return 'admin-doc';
    } else {
      return 'impacter';
    }
  }
}
